<template>
  <div id="chat-main">
    <nav-bar-top />
    <div
      id="chat-list"
      class="has-background-white"
    >
      <div v-if="chatList.length > 0">
        <div
          v-for="preview in chatList"
          :key="preview.key"
          class="chat-preview"
          :class="activeChatId === preview.messages._id ? 'chat-preview-is-active' : ''"
          @click="getActiveChat(preview._id)"
        >
          <div class="columns is-vcentered is-mobile">
            <div class="column">
              <p
                class="has-text-weight-bold is-size-6"
              >
                {{ formatOtherPartyNameInPreview(preview) }}
              </p>
              <small class="is-size-7">
                <span
                  v-if="isSenderMe(preview.messages)"
                  class="has-text-weight-bold"
                >You:</span>
                {{ truncateMessage(preview.messages.message) }}
              </small>
            </div>
            <div
              v-if="preview.unread_message_count > 0"
              class="column is-2"
            >
              <span
                class="badge is-badge-danger has-text-weight-bold"
                :data-badge="preview.unread_message_count"
              />
            </div>
            <div
              v-else
              class="column is-2"
              @click.stop="markConversationAsUnread(preview, account._id)"
            >
              <i class="far fa-sm fa-envelope-open" />
            </div>
          </div>
        </div>
      </div>
      <div
        v-else
        class="section has-text-centered"
      >
        <p class="has-text-grey-light">
          You have no new messages...
        </p>
      </div>
    </div>
    <div
      ref="messagesContainer"
      class="container chat-pane-container"
    >
      <div class="back-header">
        <button
          class="button is-rounded is-white"
          @click="closeMobilePane()"
        >
          <i class="fas fa-chevron-left" />
          &nbsp;
          Back to Messages
        </button>
      </div>
      <div class="chat-pane">
        <div id="messages">
          <div
            v-for="message in messages"
            :key="message.key"
          >
            <div
              v-if="isSenderMe(message)"
              class="msg-container"
            >
              <div class="me-container">
                <small class="sender-label-me">{{ message.author }}</small>
                <div class="msg-bubble-me">
                  {{ message.message }}
                  <div class="triangle-right" />
                </div>
                <p
                  class="is-size-7 message-timestamp"
                >
                  {{ new Date(message.dateTimeStamp).toLocaleString('en-US') }}
                </p>
              </div>
            </div>
            <div
              v-else
              class="msg-container"
            >
              <div class="others-container">
                <small class="sender-label-others">{{ message.author }}</small>
                <div class="msg-bubble-others">
                  {{ message.message }}
                  <div class="triangle-left" />
                </div>
                <p
                  class="is-size-7 message-timestamp"
                >
                  {{ new Date(message.dateTimeStamp).toLocaleString('en-US') }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <!-- Whenever editing this piece, DO NOT FORGET, to edit the duplicate divs for mobile. -->
        <!-- TODO Needs refactoring to avoid code duplication -->
        <div class="message-input-box">
          <div>
            <div class="chat-items">
              <form
                class="chat-form"
                @submit.prevent="sendMessage()"
              >
                <div class="columns is-mobile">
                  <div class="column is-10-desktop is-10-tablet is-8-mobile">
                    <div
                      v-contenteditable:newMessage="isMessageInputEnabled"
                      class="chat-input"
                      :class="isMessageInputEnabled ? '' : 'message-input-disabled'"
                    />
                  </div>
                  <div class="column no-pad-left-right">
                    <button
                      type="submit"
                      class="button is-rounded is-primary is-small has-text-weight-bold"
                      :disabled="!isMessageInputEnabled"
                    >
                      SEND
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="mobilePaneIsActive"
      class="container chat-pane-container is-mobile"
    >
      <div class="back-header">
        <button
          class="button is-rounded is-white"
          @click="closeMobilePane()"
        >
          <i class="fas fa-chevron-left" />
          &nbsp;
          Back to Messages
        </button>
      </div>
      <div class="chat-pane">
        <div id="messages">
          <div
            v-for="message in messages"
            :key="message.key"
          >
            <div
              v-if="isSenderMe(message)"
              class="msg-container"
            >
              <div class="me-container">
                <small class="sender-label-me">{{ message.author }}</small>
                <div class="msg-bubble-me">
                  {{ message.message }}
                  <div class="triangle-right" />
                </div>
                <p
                  class="is-size-7 message-timestamp"
                >
                  {{ new Date(message.dateTimeStamp).toLocaleString('en-US') }}
                </p>
              </div>
            </div>
            <div
              v-else
              class="msg-container"
            >
              <div class="others-container">
                <small class="sender-label-others">{{ message.author }}</small>
                <div class="msg-bubble-others">
                  {{ message.message }}
                  <div class="triangle-left" />
                </div>
                <p
                  class="is-size-7 message-timestamp"
                >
                  {{ new Date(message.dateTimeStamp).toLocaleString('en-US') }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="message-input-box">
          <div>
            <div class="chat-items">
              <form
                class="chat-form"
                @submit.prevent="sendMessage()"
              >
                <div class="columns is-mobile">
                  <div class="column is-10-desktop is-10-tablet is-8-mobile">
                    <div
                      v-contenteditable:newMessage="isMessageInputEnabled"
                      class="chat-input"
                      :class="isMessageInputEnabled ? '' : 'message-input-disabled'"
                    />
                  </div>
                  <div class="column no-pad-left-right">
                    <button
                      type="submit"
                      class="button is-rounded is-primary is-small has-text-weight-bold"
                    >
                      SEND
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NavBarTop from '@/components/Navigation/NavBarTop';
import { unixTimestampToDateFormat } from '@/helpers/dateHelpers';

export default {
  name: 'ChatMain',
  components: {
    NavBarTop
  },
  data () {
    return {
      chatList: [],
      newMessage: '',
      messages: [],
      isConnected: false,
      socketMessage: '',
      activeChatId: null,
      mobilePaneIsActive: false
    };
  },
  computed: {
    account () {
      return this.$store.state.user.account;
    },
    profile () {
      if (this.account.user_type === 'company') {
        return;
      }
      return this.$store.state.user.profile;
    },
    activeCandidateProfile () {
      return this.$store.state.activeCandidateProfile;
    },
    sendMessageObject () {
      if (this.chatList === [] && this.activeChatId === null) {
        return;
      }
      let activeChat = this.chatList.filter(
        chat => chat._id === this.activeChatId
      );

      return {
        author: {
          id: this.account._id,
          user_name:
            this.account.user_type === 'candidate'
              ? this.account.username
              : this.companyAuthorString,
          type: this.account.user_type
        },
        recipient: {
          id:
            activeChat[0].company === this.account._id
              ? activeChat[0].candidate
              : activeChat[0].company,
          user_name: this.activeChatMessageRecipient,
          type: this.account.user_type === 'company' ? 'candidate' : 'company'
        },
        message: this.newMessage,
        conversation_id: this.activeChatId
      };
    },
    activeRoomObject () {
      if (this.chatList === [] || this.activeChatId === null) {
        return;
      }

      let activeChat = this.chatList.filter(
        chat => chat._id === this.activeChatId
      );
      const recipientId = activeChat => {
        if (activeChat[0].admin) return '1111';
        else if (
          activeChat[0].company
          && activeChat[0].company === this.account._id
        ) { return activeChat[0].candidate; } else return activeChat[0].company;
      };
      const recipientType = activeChat => {
        if (activeChat[0].admin) return 'admin';
        else { return this.account.user_type === 'company' ? 'candidate' : 'company'; }
      };

      return {
        author: {
          id: this.account._id,
          type: this.account.user_type
        },
        recipient: {
          id: recipientId(activeChat),
          type: recipientType(activeChat)
        },
        isFromAdmin:
          !!(activeChat[0].admin && activeChat[0].admin === '1111')
      };
    },
    companyAuthorString () {
      if (this.account.user_type === 'candidate') {
        return;
      }

      let companyFirstName = this.account.first_name;
      let company = this.account.company;
      let authorString = `${companyFirstName} from ${company}`;

      return authorString;
    },
    activeChatMessageRecipient () {
      let activeChat = this.chatList.filter(
        chat => chat._id === this.activeChatId
      );

      if (this.account.user_type === 'candidate' && activeChat[0].messages.recipient === this.account.username) {
        return activeChat[0].messages.author;
      } else if (this.account.user_type === 'candidate' && activeChat[0].messages.author === this.account.username) {
        return activeChat[0].messages.recipient;
      } else if (this.account.user_type === 'company' && activeChat[0].messages.recipient === this.companyAuthorString) {
        return activeChat[0].messages.author;
      } else if (this.account.user_type === 'company' && activeChat[0].messages.author === this.companyAuthorString) {
        return activeChat[0].messages.recipient;
      } else {
        return '';
      }
    },
    isMessageInputEnabled () {
      return !this.isActiveChatFromAdmin;
    },
    isActiveChatFromAdmin () {
      return !!(this.activeRoomObject && this.activeRoomObject.isFromAdmin);
    }
  },
  created () {
    this.getChatList('isFirstLoad');
  },
  sockets: {
    success (val) {
      // console.log('Connected');
    },
    message_received (val) {
      this.appendReceivedMessage(val);
      this.getChatList();
    },
    messages_read_status_updated (val) {
      this.getChatList();
    },
    notification (val) {
      this.getChatList();
    }
  },
  methods: {
    unixTimestampToDateFormat,
    getChatList (isFirstLoad) {
      this.$store
        .dispatch('getChatList', {
          id_user: this.$store.state.user.account._id,
          type: this.$store.state.user.account.user_type
        })
        .then(response => {
          let list = response.data.data;
          list.sort(
            (a, b) => b.messages.dateTimeStamp - a.messages.dateTimeStamp
          );
          this.chatList = list;
          if (isFirstLoad === 'isFirstLoad' && list.length > 0) {
            let activeChat = this.chatList[0];
            this.getActiveChat(activeChat._id, true);
          }
        })
        .catch(error => console.log(error));
    },
    formatOtherPartyNameInPreview (preview) {
      if (preview.admin === '1111') {
        return preview.messages.author;
      } else if (this.account.user_type === 'company') {
        return preview.messages.recipient === this.companyAuthorString ? preview.messages.author : preview.messages.recipient;
      } else if (this.account.user_type === 'candidate') {
        return preview.messages.recipient === this.profile.username ? preview.messages.author : preview.messages.recipient;
      }
    },
    getActiveChat (chatId, isFirstLoad) {
      // We send this date to let backend know where we are in timeline of messages.
      let referenceDate = new Date().getTime();

      // If user is already in a room, we need to leave that room.
      if (this.activeChatId !== null) {
        this.$socket.emit('left_room', this.activeRoomObject);
      }
      // Set new active Chat ID based on the preview the user clicked on.
      // And filter from chat list to extract details.
      this.activeChatId = chatId;
      let activeChat = this.chatList.filter(
        chat => chat._id === this.activeChatId
      );

      // join room based on relevant details.
      this.$socket.emit('join_room', this.activeRoomObject);
      this.$store
        .dispatch('getActiveChat', {
          id_candidate: activeChat[0].candidate || null,
          id_company: activeChat[0].company || null,
          id_admin: '1111',
          reference_date: referenceDate
        })
        .then(response => {
          if (response.data.status !== 'error') {
            this.messages = response.data.data[0].messages;
            this.markMessagesInConversationAsRead(
              response.data.data[0]._id,
              this.account._id
            );
            setTimeout(() => {
              this.scrollToEnd();
            }, 150); // Timeout to ensure DOM elements are there before the scroll.*/

            if (!isFirstLoad) {
              this.mobilePaneIsActive = true;
            }
          } else {
            console.error(response.data.details); // This is an error message.
          }
        })
        .catch(error => console.error(error));
    },
    closeMobilePane () {
      this.mobilePaneIsActive = false;
    },
    isChatActive (index) {
      let activeChat = this.chatList.filter(
        chat => chat._id === this.activeChatId
      );

      if (
        activeChat.company === this.$store.state.activeChatUserId
        || activeChat.candidate === this.$store.state.activeChatUserId
      ) {
        return true;
      } else {
        return false;
      }
    },
    sendMessage () {
      this.$socket.emit('message_sent', this.sendMessageObject);
      this.newMessage = '';
    },
    appendReceivedMessage (message) {
      this.messages.push(message);
      this.markMessagesInConversationAsRead(
        message.conversation_id,
        this.account._id
      );
      setTimeout(() => {
        this.scrollToEnd();
      }, 500);
    },
    isSenderMe (message) {
      if (this.account.user_type === 'company') {
        if (message.author === this.companyAuthorString) {
          return true;
        }
      } else if (this.account.user_type === 'candidate') {
        if (message.author === this.account.username) {
          return true;
        }
      } else {
        return false;
      }
    },
    truncateMessage (message) {
      if (message.length > 38) {
        return `${message.slice(0, 38)}...`;
      } else {
        return message;
      }
    },
    scrollToEnd () {
      let container = this.$refs.messagesContainer;
      container.scrollTop = container.scrollHeight;
    },
    compare (a, b) {
      if (a.messages.dateTimeStamp < b.messages.dateTimeStamp) {
        return -1;
      } else if (a.messages.dateTimeStamp > b.messages.dateTimeStamp) {
        return 1;
      } else {
        return 0;
      }
    },
    markMessagesInConversationAsRead (conversationId, userId) {
      let readMessagesParams = {
        id: conversationId,
        recipient: {
          id: userId
        }
      };

      this.$socket.emit('update_message_read_user', readMessagesParams);
    },
    markConversationAsUnread (conversation, userId) {
      let messages = [];
      // We send this date to let backend know where we are in timeline of messages.
      let referenceDate = new Date().getTime();

      this.$store
        .dispatch('getActiveChat', {
          id_candidate: conversation.candidate || null,
          id_company: conversation.company || null,
          id_admin: '1111',
          reference_date: referenceDate
        })
        .then(response => {
          if (response.data.status !== 'error') {
            messages = response.data.data[0].messages.filter(
              message => message.recipient_id === this.account._id
            );
            let readMessagesParams = {
              id: conversation._id,
              recipient: {
                id: userId
              },
              messageId: messages[messages.length - 1]._id
            };
            this.$socket.emit(
              'update_conversation_as_unread',
              readMessagesParams
            );
          } else {
            console.error(response.data.details); // This is an error message.
          }
        })
        .catch(error => console.error(error));
    }
  }
};
</script>

<style lang="scss" scoped>
#chat-main {
  height: 100vh;
  overflow: auto;
}

@media screen and (min-width: 0px) {
  .container {
    max-width: none;
    width: 100%;
    height: calc(100% - 70px);
  }
}

.is-size-7 {
  line-height: 10px;
}

#chat-list {
  position: absolute;
  top: 3.75rem;
  left: 0;
  height: calc(100vh - 3.75rem);
  padding: 0;
  overflow-y: auto;
  width: 320px;
  box-shadow: 0 -2px 20px 0 rgba(133, 191, 244, 0.2);
  z-index: 1;
}

.chat-preview {
  padding: 1rem 1.5rem;
  border-bottom: solid 1px lightgray;
  cursor: pointer;
}

.chat-preview:hover {
  background-color: whitesmoke;
}

.chat-pane {
  width: calc(100vw - 340px);
  background-color: transparent;
  position: absolute;
  right: 0;
  top: 0;
  padding: 1rem 0 4rem 0;
  margin-bottom: 3.5rem;
}

.message-input-box {
  position: fixed;
  bottom: 0px;
  right: 0px;
  min-height: 70px;
  width: calc(100% - 320px);
  background-color: white;
  padding: 1rem;
  box-shadow: 0 -2px 20px 0 rgba(133, 191, 244, 0.2);
}

.bottom {
  position: absolute;
  background-color: #fff;
  height: 86px;
  border-top: 1px solid lightgray;
  bottom: 0;
  left: 0;
  width: 100%;
}

/* stack message send box elements on smaller screens */
@media only screen and (max-width: 400px) {
  .chat-items {
    margin-left: 0;
    margin-top: 20px;
  }
}

.chat-input {
  display: inline-block;
  position: relative;
  width: 100%;
  color: dimgray;
  appearance: none;
  border: none;
  border: 1px solid #ccc;
  border-radius: 18px;
  position: relative;
  min-height: 34px;
  padding: 0.5rem 1rem;
  font-size: 13px;
  margin-bottom: -8px;
  resize: none;
  outline: none;
  user-select: text;
  -webkit-user-select: text;
  -moz-user-modify: read-write;
  -webkit-user-modify: read-write;
  overflow-x: wrap;
  word-wrap: break-word;
  background-color: $powder-light-grey;
}

.message-input-disabled {
  border: none;
  background-color: $white-ter;
  -webkit-user-select: none; /* Safari 3.1+ */
  -moz-user-select: none; /* Firefox 2+ */
  -ms-user-select: none; /* IE 10+ */
  user-select: none; /* Standard syntax */
  -moz-user-modify: read-only;
  -webkit-user-modify: read-only;
}

.msg-container {
  font-size: 14px;
}

.me-container {
  width: 90%;
  max-width: 300px;
  margin: 1rem 0;
  margin-left: auto;
  text-align: right;
}

.others-container {
  width: 90%;
  max-width: 300px;
  margin: 1rem 0;
}

%msg-bubble {
  -webkit-hyphens: auto;
  -moz-hyphens: auto;
  -ms-hyphens: auto;
  hyphens: auto;
}

.msg-bubble-me {
  @extend %msg-bubble;
  position: relative;
  color: $link-invert;
  padding: 8px 20px;
  border-radius: 20px;
  margin: 5px 0;
  background-color: $primary;
  text-align: left;
  margin: 0;
}

.msg-bubble-others {
  @extend %msg-bubble;
  position: relative;
  padding: 8px 20px;
  border-radius: 20px;
  margin: 5px 0;
  background-color: $grey-lighter;
  margin: 0;
}

.triangle-right {
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 15px 0 15px 15px;
  border-color: $primary transparent transparent;
  position: absolute;
  right: 4px;
}

.triangle-left {
  width: 0;
  height: 0;
  border-style: solid;
  border-width: 15px 15px 0 0;
  border-color: $grey-lighter transparent transparent;
  position: absolute;
  left: 4px;
}

// TODO -- this is a duplicate class, remove!
.has-text-weight-bold {
  font-weight: bold;
}

.sender-label-me {
  @extend .has-text-weight-bold;
  padding-right: 8px;
  font-size: 12px;
}

.sender-label-others {
  @extend .has-text-weight-bold;
  padding-left: 8px;
  font-size: 12px;
}

.chat-preview-is-active {
  background-color: whitesmoke;
}

.back-header {
  display: none;
}

.chat-pane-container {
  top: 3.75rem;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

@media screen and (max-width: 767px) {
  .chat-pane-container {
    display: none;
  }

  .chat-pane {
    width: 100%;
  }

  #chat-list {
    width: 100%;
  }

  .message-input-box {
    width: 100%;
  }
  .back-header {
    display: block;
    position: fixed;
    background-color: white;
    top: 0;
    left: 0;
    width: 100vw;
    height: 3.75rem;
    z-index: 100;
  }

  .back-header:hover .button {
    background-color: white;
    cursor: pointer;
  }

  .chat-pane-container.is-mobile {
    display: block;
    z-index: 99;
    background-color: white;
  }
}

@media screen and (min-width: 768px) {
  .chat-pane-container.is-mobile {
    display: none;
  }
}

.message-timestamp {
  padding: 0.5rem 0.75rem;
}
</style>
